<template>
  <div class="w3-content w3-container w3-padding-64" id="rooms">
    <h3 class="w3-center">ROOMS</h3>
    <p class="w3-center">
      <em>{{ subtitle }}</em>
    </p>

    <div class="w3-container" style="margin: 0px; padding: 0px">
      <p>{{ guide }}</p>

      <!-- buttons for tab activation -->
      <div class="w3-bar w3-black">
        <button
          v-for="(room, page_index) in rooms.rooms"
          :key="page_index"
          class="w3-bar-item w3-button tablink"
          :class="active_page == page_index ? 'active_page' : 'not_active_page'"
          @click="set_active_page(page_index)"
        >
          {{ room.room_name }}
        </button>
      </div>

      <!-- tab contents -->
      <div
        v-for="(room, page_index) in rooms.rooms"
        :key="page_index"
        class="w3-container w3-border room w3-animate-zoom"
        :class="active_page == page_index ? 'blockClass' : 'noneClass'"
      >
        <h2>{{ room.room_name }}</h2>
        <div
          class="content"
        >
          <p v-for="des in room.des" :key="des">
            {{ des }}
          </p>
        </div>

        <div
          v-for="(photo, photo_index) in room.photos"
          :key="photo_index"
          :class="active_photo == photo_index ? 'blockClass' : 'noneClass'"
        >
          <!--        <div class="image_container w3-show w3-hide-small">-->
          <div class="image_container">
            <img :src="photo.photo" style="width: 100%" />
<!--            <div
              class="content w3-show w3-hide-small"
              :class="active_photo == photo_index ? 'blockClass' : 'noneClass'"
            >
              <p v-for="des in room.des" :key="des">
                {{ des }}
              </p>
            </div>-->
          </div>
        </div>

        <div class="caption-container w3-hide w3-hide-large w3-hide-medium">
          <!--    <p id="caption"></p>-->
          <p>{{ photo_caption }}</p>
        </div>

        <div class="row">
          <div
            v-for="(photo, photo_index) in room.photos"
            :key="photo_index"
            class="column"
          >
            <img
              @click="set_active_photo(photo_index)"
              class="demo cursor"
              :src="photo.photo"
              style="width: 100%; height: 60%"
              alt="Mountains and fjords"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { language_util } from "@/classes/language/language_util.js";
import { rooms_utils } from "@/classes/rooms/rooms_utils.js";
export default {
  components: {},
  setup() {
    const active_page = ref(0);
    const active_photo = ref(0);
    const photo_caption = computed(
      () => rooms.value.rooms[active_page.value].photos[active_photo.value].what
    );
    const subtitle = computed(() => rooms_utils.get_subtitle(language.value));
    const guide = computed(() => rooms_utils.get_guide(language.value));
    const rooms = computed(() => {
      let temp = rooms_utils.get_rooms_info(language.value);

      return rooms_utils.get_rooms_info(language.value);
    });
    const language = computed(() => {
      return language_util.get_language();
    });

    function set_active_page(index) {
      active_page.value = index;
      active_photo.value = 0;
    }

    function set_active_photo(index) {
      active_photo.value = index;
    }

    return {
      subtitle,
      guide,
      active_page,
      active_photo,
      set_active_page,
      set_active_photo,
      photo_caption,
      rooms,
    };
  },
};
</script>

<style scoped>
.active {
  color: red;
}

img {
  max-width: 100%;
  border-radius: 5px;
}
.blockClass {
  display: block;
}

.noneClass {
  display: none;
}

/* Container for image text */
.caption-container {
  text-align: center;
  background-color: #222;
  padding: 2px 16px;
  color: white;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Six columns side by side */
.column {
  float: left;
  width: 16.66%;
}

.column img {
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 5px;
}
/* Add a transparency effect for thumnbail images */
.demo {
  opacity: 0.6;
}

.active_page {
  background-color: red;
  color: white;
}
.not_active_page {
  background-color: black;
  color: white;
}

.active,
.demo:hover {
  opacity: 1;
}
.image_container img {
  vertical-align: middle;
}

.image_container .content {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0); /* Fallback color */
  background: rgba(0, 0, 0, 0.5); /* Black background with 0.5 opacity */
  color: #f1f1f1;
  width: 100%;
  padding: 20px;
}
</style>